import {useState} from "react";
import SelectServices from "./SelectServices";
import GetInfoCarInfo from "./GetInfoCarInfo";
import Discount from "./Discount";

const InitConfirm=({handleServiceSelect,pid,handleGetProcess,handleConfirm,paymentInfo,accessToken,processInfo,prices,selectedServices})=>{
    const isResetActive=processInfo.passed_steps.includes(processInfo.current_step.name)||!!processInfo.reseted_step;

    const [step,setStep]=useState(isResetActive? 3:1);
    const handleNext=()=>{
        setStep(step+1)
    }
    const handlePrev=()=>{
        setStep(step-1)
    }


    return <div>
        {processInfo&&processInfo.current_step.name==="InitConfirm"&&step===1 && <Discount pid={pid} onClick={()=>handleNext()} prices={prices} getProcess={handleGetProcess} processInfo={processInfo} token={accessToken}/>}
        {processInfo&&processInfo.current_step.name==="InitConfirm"&&step===2 &&selectedServices&& <SelectServices processInfo={processInfo} discount={processInfo.discount} handleNext={handleNext} handlePrev={handlePrev} onSelect={handleServiceSelect} prices={prices} services={selectedServices} />}
        {processInfo&&processInfo.current_step.name==="InitConfirm"&&step===3 &&selectedServices&&<GetInfoCarInfo processInfo={processInfo}  handleNext={handleNext} handleConfirm={handleConfirm} handlePrev={handlePrev} selectedServices={selectedServices}/>}

    </div>

}
export default InitConfirm;